
export enum CountryEnum {
    Sweden = "SE",
    Norway = "NO",
    Denmark = "DK",
    Finland = "FI",
    Other = ""
}
